export const enajenacion_item = [
    {
        "anio": "2022",
        "Convocatorias": [
            {
                "Convocatoria": "Convocatoria 01",
                "url": "",
                "Extras": [

                    {
                        "NombreValor": "Convocatoria",
                        "url2": "/pdf/Enajenacion/2022/01/CON_DGRMyS_01_2022.pdf"
                    },
                    {
                        "NombreValor": "Bases",
                        "url2": "/pdf/Enajenacion/2022/01/BA_DGRMyS_01_2022.pdf"
                    },
                    {
                        "NombreValor": "Atento aviso",
                        "url2": "/pdf/Enajenacion/2022/01/AV_OM_DGRMyS_01_2021.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio": "2021",
        "Convocatorias": [
            {
                "Convocatoria": "Convocatoria 01",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Bases",
                        "url2": "/pdf/Enajenacion/2021/OM_DGRMyS_01_2021.pdf"
                    },
                    {
                        "NombreValor": "Acta de junta de aclaraciones",
                        "url2": "/pdf/Enajenacion/2021/JA_OM_DGRMyS_01_2021.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Acta de recepción y apertura de propuestas",
                        "url2": "/pdf/Enajenacion/2021/RAP_OM_DGRMyS_01_2021.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Acta de fallo",
                        "url2": "/pdf/Enajenacion/2021/AF_OM_DGRMyS_01_2021.pdf"
                    }
                ]
            },
            {
                "Convocatoria": "Convocatoria 02",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Bases",
                        "url2": "/pdf/Enajenacion/2021/OM_DGRMyS_02_2021.pdf"
                    },
                    {
                        "NombreValor": "Forma de pago",
                        "url2": "/pdf/Enajenacion/2021/FP_OM_DGRMyS_02_2021.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Listado de lote de bienes",
                        "url2": "/pdf/Enajenacion/2021/LB_OM_DGRMyS_02_2021.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Aclaraciones",
                        "url2": "/pdf/Enajenacion/2021/AC_OM_DGRMyS_02_2021.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Atento aviso",
                        "url2": "/pdf/Enajenacion/2021/AVISO_OM_DGRMyS_02_2021.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Entrega de documentos",
                        "url2": "/pdf/Enajenacion/2021/DOCUMENTOS_OM_DGRMyS_02_2021.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio": "2020",
        "Convocatorias": [
            {
                "Convocatoria": "Convocatoria 01",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Bases",
                        "url2": "../wp-content/enajenacion/OM-DGRMyS-01/2020.pdf"
                    }
                    ,
                    
                    {
                        "NombreValor": "Cancelación",
                        "url2": "/pdf/Enajenacion/Cancelacion_01_2020.pdf"
                    }
                ]
            },
            {
                "Convocatoria": "Convocatoria 02",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Bases",
                        "url2": "../wp-content/enajenacion/OM-DGRMyS-02-2020.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Acta de junta de aclaraciones",
                        "url2": "/pdf/Enajenacion/JA_om_dgrmys_02_2020.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Acta de recepción y apertura de propuestas",
                        "url2": "/pdf/Enajenacion/RAP_om_dgrmys_02_2020.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Acta de suspensión",
                        "url2": "/pdf/Enajenacion/AS_om_dgrmys_02_2020.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Continuación de proceso",
                        "url2": "/pdf/Enajenacion/CP_om_dgrmys_02_2020.pdf"
                    }
                    ,
                    {
                        "NombreValor": "Acta de fallo",
                        "url2": "/pdf/Enajenacion/AF_om_dgrmys_02_2020.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio": "2019",
        "Convocatorias": [
            {
                "Convocatoria": "Convocatoria 01",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Bases",
                        "url2": "../wp-content/enajenacion/OM-DGRMyS-01/2019.pdf"
                    }
                    , {
                        "NombreValor": "Acta de junta de aclaraciones",
                        "url2": "/pdf/Enajenacion/JA_om_dgrmys_01_2019.pdf"
                    }
                    , {
                        "NombreValor": "Acta de recepción y apertura de propuestas",
                        "url2": "/pdf/Enajenacion/RAP_om_dgrmys_01_2019.pdf"
                    }
                    , {
                        "NombreValor": "Acta de fallo",
                        "url2": "/pdf/Enajenacion/AF_om_dgrmys_01_2019.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio": "2018",
        "Convocatorias": [
            {
                "Convocatoria": "Convocatoria 01",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Convocatoria",
                        "url2": "../bases-vehiculos-om-dgrmys-01-2018.pdf"
                    }
                ]
            },
            {
                "Convocatoria": "Convocatoria 02",
                "url": "",
                "Extras": [
                    {
                        "NombreValor": "Convocatoria",
                        "url2": "../wp-content/enajenacion/licitacion_publica_no_omdgrmys-02-2018.pdf"
                    }
                ]
            }
        ]
    }

]